import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { GAMES } from "@/lib/games";

import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import GamePage from "@/pages/GamePage";
import PreviousResults from "@/pages/PreviousResults";
import CommonNumbers from "@/pages/CommonNumbers";
import AllResults from "@/pages/AllResults";
import AboutUs from "@/pages/AboutUs";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ManageResults from "@/pages/admin/ManageResults";
import ChangePassword from "@/pages/admin/ChangePassword";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/all-results" element={<AllResults />} />
            <Route path="/about" element={<AboutUs />} />
            {/* legacy redirects */}
            <Route path="/about-us" element={<Navigate to="/about" replace />} />
            <Route path="/previous-results" element={<Navigate to="/all-results" replace />} />
            <Route path="/common-number" element={<Navigate to="/all-results" replace />} />

            {GAMES.map((g) => (
              <Route key={g.slug} path={`/${g.slug}`}>
                <Route index element={<GamePage slug={g.slug} />} />
                <Route path="previous-result" element={<PreviousResults slug={g.slug} />} />
                <Route path="common-number" element={<CommonNumbers slug={g.slug} />} />
              </Route>
            ))}
            {/* legacy per-game redirects (from previous URL scheme) */}
            {GAMES.map((g) => (
              <Route key={`legacy-${g.slug}`} path={`/${g.slug}-result`}>
                <Route index element={<Navigate to={`/${g.slug}`} replace />} />
                <Route path="previous-results" element={<Navigate to={`/${g.slug}/previous-result`} replace />} />
                <Route path="common-number" element={<Navigate to={`/${g.slug}/common-number`} replace />} />
              </Route>
            ))}

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="results" element={<ManageResults />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
